const FullScreen = ({image, alt, hideFullScreen}) => {


    return (
        <div className="fullscreen">
            <button onClick={hideFullScreen}>Close</button>
            <img src={image} alt={alt}  />
        </div>
    );
}

export default FullScreen;